import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import type {
  UpsertSubscriptionParticipationsRequest,
  UpsertSubscriptionParticipationsResponse,
  SubscriptionParticipationsQueryParams,
} from "@/interfaces/participation";
import { clubUUID, participations } from "@/shared/state";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;

export function useSubscriptionParticipations() {
  const isRequestParticipations = ref<boolean>(false);
  const errorParticipations = ref<string | null>(null);

  const upsertParticipations = async (
    body: UpsertSubscriptionParticipationsRequest 
  ): Promise<UpsertSubscriptionParticipationsResponse | null> => {
    try {
      isRequestParticipations.value = true;
      errorParticipations.value = null;
 
      const url = `${API_URL}member/subscription/participations/${clubUUID.value}`
 

      const response = await authenticatedFetch(
        url,
        {
          method: "POST",
          body: JSON.stringify({
            ...body,
            clubUUID: clubUUID.value,
          }),
        },
        true,
        "",
        false,
      );

      isRequestParticipations.value = false;
      return response as UpsertSubscriptionParticipationsResponse;
    } catch (err: unknown) {
      isRequestParticipations.value = false;
      errorParticipations.value =
        err instanceof Error ? err.message : "An error occurred";
      return null;
    }
  };

  const fetchParticipations = async (
    body: SubscriptionParticipationsQueryParams,
  ) => {
    try {
      isRequestParticipations.value = true;
      errorParticipations.value = null;
      participations.data = [];

      const response = await authenticatedFetch(
        `${API_URL}participations/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        participations.data = response?.data || [];
        isRequestParticipations.value = false;
      }
    } catch (err: any) {
      errorParticipations.value = err.message;
      isRequestParticipations.value = false;
    }
  };
 
  return {
   
    fetchParticipations,
    upsertParticipations,
    isRequestParticipations,
    errorParticipations,
  };
}
